const styles = (theme) => ({
  // Animation utilisée en style inline sur l'icône ✨ des crédits IA
  "@global": {
    "@keyframes pulse": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.55 },
    },
  },
  root: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
  },
  updateAbo: {
    margin: theme.spacing(1),
    color: "white",
    backgroundColor: "#556aed",
    "&:hover": {
      backgroundColor: "#3b4eca",
    },
  },
  deleteAbo: {
    margin: theme.spacing(1),
    color: "white",
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "#ac1212",
    },
  },

  title: {
    flexGrow: 1,
  },
  formContainer: {
    paddingTop: "30px",
    paddingBottom: "30px",
    width: "90%",
  },
  form: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "auto",
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
  },
  textField: {
    minWidth: 200,
    backgroundColor: "white",
  },
  list: {
    backgroundColor: theme.palette.lightGrey.main,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    borderRadius: 5,
    listStyle: "none",
  },
  buttonListPlus: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 5,
    color: "white",
  },
  returnButtonLink: {
    textDecoration: "none",
    margin: theme.spacing(2),
  },
  danger: {
    color: "red",
  },
  passwordForgotten: {
    textDecoration: "none",
    color: "#6879ab",
    marginLeft: 12,
  },
  saveButton: {
    backgroundColor: theme.palette.orange.main,
    color: "#ffffff",
    fontSize: 16,
    fontWeight: 500,
    borderRadius: 8,
    height: 40,
    marginTop: 9,
    marginBottom: 9,

    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
  },
  deactivateToursButton: {
    margin: theme.spacing(1),
    color: "white",
    backgroundColor: "#556aed",
    "&:hover": {
      backgroundColor: "#3b4eca",
    },
  },
  optionsContainer: {
    [theme.breakpoints.up("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "50%",
    },
    [theme.breakpoints.up("md")]: {
      width: "40%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "30%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "20%",
    },
  },
  optionUnlocked: {
    marginLeft: "12px",
    marginBottom: "6px",
    color: "green",
    fontWeight: 300,
    fontSize: "12px",
  },
  banner: {
    backgroundColor: "#B85A00",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 900,
    padding: "15px",
    color: "white",
    borderRadius: "8px",
    marginBottom: "16px",
    // marginBottom: "10px",
  },
  optionLocked: {
    marginLeft: "12px",
    marginBottom: "6px",
    color: "red",
    fontWeight: 300,
    fontSize: "12px",
  },
  accountOptionsText: {
    marginLeft: "12px",
    marginBottom: "4px",
    fontWeight: 500,
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between",
  },
  reactivateButtonText: {
    marginLeft: "12px",
    marginBottom: "4px",
    fontWeight: 200,
    fontSize: "14px",
  },
  aiCreditsCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    padding: "24px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    position: "absolute",
    top: "100px",
    right: "32px",
    width: "300px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    "@media (max-width: 960px)": {
      position: "relative",
      top: 0,
      right: 0,
      width: "100%",
      marginBottom: "24px",
    },
  },
  aiCreditsHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  aiCreditsTitle: {
    fontSize: "20px",
    fontWeight: 600,
    background: "linear-gradient(135deg, #FF0080, #7928CA)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  aiCreditsValue: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "16px",
    backgroundColor: "rgba(124, 58, 237, 0.05)",
    borderRadius: "12px",
    marginBottom: "8px",
  },
  aiCreditsNumber: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#7928CA",
  },
  aiCreditsLabel: {
    fontSize: "14px",
    color: "#666",
  },
  rechargeButton: {
    background: "linear-gradient(135deg, #FF0080, #7928CA)",
    color: "white",
    textTransform: "none",
    borderRadius: "12px",
    padding: "12px 24px",
    boxShadow: "0 4px 15px rgba(124, 58, 237, 0.2)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(124, 58, 237, 0.3)",
    },
  },
  mainContent: {
    marginLeft: 180,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  dangerZoneCard: {
    backgroundColor: "white",
    borderRadius: "24px",
    padding: "32px 40px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
    border: "1px solid #FECACA",
    marginTop: "24px",
    marginBottom: "40px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px",
    },
  },
  dangerZoneTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#DC2626",
    marginBottom: "4px",
  },
  dangerZoneDescription: {
    fontSize: "14px",
    color: "#6B7280",
    marginBottom: "20px",
  },
  deleteAccountButton: {
    backgroundColor: "transparent",
    color: "#DC2626",
    border: "1px solid #DC2626",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    padding: "10px 20px",
    "&:hover": {
      backgroundColor: "#FEF2F2",
    },
  },
  deleteAccountDialog: {
    "& .MuiDialog-paper": {
      borderRadius: "16px",
      padding: "32px",
      maxWidth: "480px",
      width: "100%",
      backgroundColor: "#1F2937",
      border: "1px solid rgba(220, 38, 38, 0.3)",
      [theme.breakpoints.down("xs")]: {
        padding: 20,
        margin: 16,
      },
    },
  },
  statsRow: {
    flexWrap: "wrap",
  },
  actionsRow: {
    flexWrap: "wrap",
  },
  statCard: {
    minWidth: 96,
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    },
  },
  pillButton: {
    transition: "filter 0.2s ease",
    "&:hover": {
      filter: "brightness(0.9)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },
  adminCode: {
    overflowWrap: "anywhere",
  },
  deleteDialogIcon: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "16px",
  },
  deleteDialogTitle: {
    color: "#EF4444",
    fontSize: "22px",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "12px",
  },
  deleteDialogText: {
    color: "rgba(255, 255, 255, 0.85)",
    fontSize: "14px",
    lineHeight: "1.6",
    textAlign: "center",
    marginBottom: "24px",
  },
  deleteDialogInstruction: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "13px",
    textAlign: "center",
    marginBottom: "12px",
  },
  deleteDialogInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      color: "white",
      "& fieldset": {
        borderColor: "rgba(255, 255, 255, 0.2)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(220, 38, 38, 0.5)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#EF4444",
      },
    },
    "& .MuiInputBase-input": {
      color: "white",
      textAlign: "center",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "2px",
    },
  },
  deleteDialogActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    marginTop: "24px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  deleteDialogCancelButton: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    padding: "10px 24px",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.18)",
    },
  },
  deleteDialogConfirmButton: {
    backgroundColor: "#EF4444",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 24px",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: "#DC2626",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(239, 68, 68, 0.3)",
      color: "rgba(255, 255, 255, 0.4)",
    },
  },
});

export default styles;
